import React, { useCallback, memo, forwardRef } from 'react';
import { X } from 'lucide-react';

import styles from './styles/RightSidebar.module.css';

const RightSidebar = forwardRef(({ isOpen, onClose, children }, ref) => {
    const handleOverlayClick = useCallback(e => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    }, [onClose]);

    return (
        <>
            <div
                className={`${styles.overlay} ${isOpen ? styles.overlayVisible : ''}`}
                onClick={handleOverlayClick}
            />
            <div className={`${styles.sidebar} ${isOpen ? styles.sidebarVisible : ''}`}>
                <button
                    className={styles.closeButton}
                    onClick={onClose}
                    aria-label="Close sidebar"
                >
                    <X size={20} />
                </button>
                <div ref={ref} className={styles.content}>
                    {children}
                </div>
            </div>
        </>
    );
});

export default memo(RightSidebar);
